import { render, staticRenderFns } from "./PagePrivacy.vue?vue&type=template&id=fde46860&scoped=true&"
import script from "./PagePrivacy.vue?vue&type=script&lang=js&"
export * from "./PagePrivacy.vue?vue&type=script&lang=js&"
import style0 from "../../styles/content-page.css?vue&type=style&index=0&id=fde46860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde46860",
  null
  
)

export default component.exports